import { useState } from "react";
import { ImageChange as ImageChangeType } from "@eragonj/copicake-fabric/dist/types/utils";
import { useTranslation } from "react-i18next";

interface IProps {
  change: ImageChangeType;
  onValueUpdated: (change: ImageChangeType) => void;
}

function ImageChange({ change, onValueUpdated }: IProps) {
  const { t } = useTranslation();
  const [name, setName] = useState(change.name);
  const [src, setSrc] = useState(change.src);

  return (
    <>
      <div className="flex space-x-2">
        <div className="w-full">
          <span className="text-sm">{t("playground_name")}</span>
          <span className="px-2 text-xs font-bold text-red-500">
            {t("common_required")}
          </span>
        </div>
        <div className="w-full">
          <span className="text-sm">{t("playground_src")}</span>
          <span className="px-2 text-xs font-bold text-gray-400">
            {t("common_optional")}
          </span>
        </div>
      </div>
      <div className="flex space-x-2">
        <input
          className="focus:shadow-outline w-full appearance-none rounded border py-2 px-3 leading-tight text-gray-700 shadow focus:outline-none"
          type="text"
          placeholder={t("playground_name")}
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            onValueUpdated({ ...change, name: e.target.value });
          }}
        />

        <input
          className="focus:shadow-outline w-full appearance-none rounded border py-2 px-3 leading-tight text-gray-700 shadow focus:outline-none"
          type="text"
          placeholder={t("playground_src")}
          value={src}
          onChange={(e) => {
            setSrc(e.target.value);
            onValueUpdated({ ...change, src: e.target.value });
          }}
        />
      </div>
    </>
  );
}

export default ImageChange;
